import './style.scss';
import { useFAQ, useDataFAQ } from './hooks';
import { LoadingContainer, LoadingSize } from 'views/mutual/loading';
import { useAuthStore } from 'views/auth/useAuth';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { NotFoundData, NotFoundDataBackPageType } from 'views/mutual/notFoundData';
import { ProductType } from 'constants/productType';

export const Faq = () => {
  const { id } = useParams<{ id: string }>();
  const productType = Number(id);
  const { openIds, stateFAQ, faqData, openId, faqContentsListLord } = useFAQ(productType);
  const { faqDataLord } = useDataFAQ(productType);
  const isLogin = useAuthStore((state) => state.isLogin);
  return (
    <LoadingContainer isLoading={faqDataLord} size={LoadingSize.Small}>
      <div className={!isLogin ? 'anothermain' : ''}>
        <div className="FAQWrapper">
          {productType === ProductType.LeaseFund ?
          (
            <>
            <div className="FAQHeader">オペレーティング・リース事業 契約締結前の情報提供に伴うご説明（FAQ）</div>
            <div className='SubFAQHeader'>
              <div className="textFAQ">
                本FAQは、オペレーティング・リース事業の契約締結前の情報提供に際してご説明するべき内容を一覧にまとめたものです。
              </div>
              <div className="textFAQ">
                本FAQを読んでも解決できない事項については、画面上部の「お問い合わせ」からご連絡ください。担当者よりお電話などにてご説明いたします。
              </div>
            </div>
          </>
          ) : productType === ProductType.OverseasRealEstate ? (
            <>
            <div className="FAQHeader">米国不動産投資事業　契約締結前の情報提供に伴うご説明（FAQ）</div>
            <div className='SubFAQHeader'>
              <div className="textFAQ">
                本FAQは、米国不動産投資事業の契約締結前の情報提供に際してご説明するべき内容を一覧にまとめたものです。
              </div>
              <div className="textFAQ">
                本FAQを読んでも解決できない事項については、画面上部の「お問い合わせ」からご連絡ください。担当者よりお電話などにてご説明いたします。
              </div>
            </div>
            </>
          ):(
            <>
            <NotFoundData
              backPageType={{
                kind: 'home',
              }}
            />
            </>
          )}

          {/* 大項目 */}
          {faqData?.GetFaqList?.Data?.map((data, index) => {
            //複数項目
            //const isOpen = openIds.includes(data!.ID);

            //単一項目
            const isOpen = openId === data!.ID;

            return (
              <div key={data!.ID} className="mainFAQFrame">
                <div className="informationFAQFrame" id={`faq-item-${data!.ID}`} onClick={() => stateFAQ(data!.ID)}>
                  <div className="informationFAQNumber">
                    <div className="textFAQ_title">{data!.ID}</div>
                  </div>
                  <div className="informationFAQTitle">
                    <div className="textFAQ_title">{data!.Title}</div>
                  </div>
                  <div className="acordingFAQ">
                    <div className="textFAQ_Acord">{isOpen ? '−' : '+'}</div>
                  </div>
                </div>

                {/* 小項目 */}
                <div className={`contentFAQ ${isOpen ? 'open' : ''}`}>
                  <LoadingContainer isLoading={faqContentsListLord} size={LoadingSize.Small}>
                    {data?.QaList?.map((item, index) => (
                      <div key={index}>
                        {/* Question */}
                        <div className="questionField">
                          <div className="textFAQ">
                            Q{data!.ID}-{item?.QAID}:
                          </div>
                          <div
                            className="textFAQ"
                            style={{ whiteSpace: 'pre-line' }}
                            dangerouslySetInnerHTML={{ __html: item?.Question || '' }}
                          />
                        </div>
                        {/* Answer */}
                        <div className="answerField">
                          <div className="textFAQ">
                            A{data!.ID}-{item?.QAID}:
                          </div>
                          <div
                            className="textFAQ"
                            style={{ whiteSpace: 'pre-line' }}
                            dangerouslySetInnerHTML={{ __html: item?.Answer || '' }}
                          />
                        </div>
                      </div>
                    ))}
                  </LoadingContainer>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </LoadingContainer>
  );
};